export class PageObject {
 
	// looking for existing slug in pageobject
	// returns the json for the given url
	
	// @array = complete json array from kirby
	// @slug = current slug

	// get data for slug in json
	pageObjectForSlugFromArray(sulgname, array){
	  let localStorage = array 	
      let data = [];
      for (var i = 0; i < localStorage.length ; i++) {
        if ( localStorage[i].slug === sulgname ) {
            data.push(localStorage[i]);
        }
      }
      return data
    }
}
  


// WEBPACK FOOTER //
// ./src/util/pageobject.js